var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "root",
    staticClass: "lit-md",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }